<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-partnership-activity-mail-recipient-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Recipient
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="(errors.name || [])[0]"
            />

            <TextFormGroup
                v-model="data.email"
                name="email"
                label="Email"
                :error="(errors.email || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup.vue'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {FormGroup, DateFormGroup, SelectWidget, TextFormGroup},

  mixins: [Errors],

  props: {
    partnershipActivityMail: {
      required: true
    },
  },

  data() {
    return {
      data: {},
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/partnership-activity-mail-recipients', {
        ...this.data,
        partnership_activity_mail_id: this.partnershipActivityMail.id
      })
          .then(response => {
            notify.success('The recipient was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
